import RevealText from "../components/RevealText";
import ScrollReveal from "../components/ScrollReveal";
import TonalPanel from "../components/TonalPanel";

export default function House() {
  return (
    <div className="pt-32 md:pt-44">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <p className="text-[10px] uppercase tracking-eyebrow text-ink/60 mb-8">About</p>
        <RevealText
          as="h1"
          className="font-serif-display text-[13vw] md:text-[9vw] leading-[0.9] tracking-[-0.02em] max-w-[22ch]"
          lines={["The House", <span key="i" className="italic font-serif-italic">of Korv</span>]}
        />
        <div className="mt-12 grid grid-cols-12 gap-6 md:gap-10">
          <p className="col-span-12 md:col-span-6 text-[17px] leading-[1.6] text-ink/80 max-w-[52ch]">
            House of Korv is a modern luxury beauty house devoted to the art of quiet luxury. Defined by clean formulations, refined craftsmanship, and timeless design, each collection reflects a philosophy of beauty that values discretion over excess. We create modern beauty essentials that are understated, intentional, and deeply personal — designed to become part of a lasting ritual rather than a passing trend.
          </p>
          <p className="col-span-12 md:col-span-5 md:col-start-8 text-[15px] leading-[1.6] text-ink/70 max-w-[46ch]">
            The first volume is the lip. What follows is designed for the long form — a series of chapters, released only when they are finished. Each will feel like the same handwriting, in a room we have not yet shown you.
          </p>
        </div>
      </div>

      <section className="mt-24 md:mt-40 border-y border-ink/15 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6">
          {[
            { k: "Founded", v: "MMXXVI, quietly." },
            { k: "Maisons", v: "Charlotte · London · Accra" },
            { k: "Discipline", v: "The removal of everything unnecessary." },
            { k: "Volume I", v: "Lip. Balm. Gloss. Oil." },
          ].map((r, i) => (
            <ScrollReveal key={i} delay={i * 0.06} className="col-span-6 md:col-span-3">
              <p className="text-[10px] uppercase tracking-editorial text-ink/55 mb-3">{r.k}</p>
              <p className="font-serif-display text-2xl md:text-3xl leading-[1.1] max-w-[20ch]">{r.v}</p>
            </ScrollReveal>
          ))}
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-10">
          <ScrollReveal className="col-span-12 md:col-span-6">
            <TonalPanel
              bg="taupe"
              tubeColor="#e6ddcf"
              cap="light"
              sublabel="LIP GLOSS"
              fig="Maison · Charlotte"
              caption="1236 Keydet Dr · Est. MMXXVI"
              chapter="The House"
              ratio="aspect-[3/4]"
            />
          </ScrollReveal>
          <div className="col-span-12 md:col-span-5 md:col-start-8 md:pt-24 space-y-10">
            <ScrollReveal>
              <p className="text-[10px] uppercase tracking-eyebrow text-ink/60 mb-4">On restraint</p>
              <p className="font-serif-display text-3xl md:text-4xl leading-[1.1]">
                We believe the finest work in beauty resembles the finest work in architecture — the removal of every element that is not strictly necessary.
              </p>
            </ScrollReveal>
            <ScrollReveal delay={0.1}>
              <p className="text-[10px] uppercase tracking-eyebrow text-ink/60 mb-4">On time</p>
              <p className="text-[16px] leading-[1.6] text-ink/80">
                Products are released when they are finished — not when they are due. We work slowly, and we prefer to be quiet about what has not yet arrived.
              </p>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-plum text-bone">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-5">
            <p className="text-[10px] uppercase tracking-eyebrow text-bone/60 mb-6">The Founder</p>
            <h3 className="font-serif-display text-5xl md:text-7xl leading-[0.95] max-w-[14ch]">
              <span className="italic font-serif-italic">Rita</span> Korvie
            </h3>
            <p className="mt-6 text-[13px] uppercase tracking-editorial text-bone/70">Charlotte · Est. MMXXVI</p>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 space-y-6">
            <p className="text-[17px] leading-[1.6] text-bone/90 max-w-[52ch]">
              My earliest beauty memories began with curiosity. Today, that same curiosity has become a pursuit of clean formulas, timeless design, and quiet luxury. Korv is where those ideas come together.
            </p>
            <p className="font-sans-tight text-[13px] md:text-[14px] leading-[1.7] uppercase text-bone/85 max-w-[46ch] tracking-[0.22em] pl-4 border-l border-bone/40">
              A house engineered for the century ahead — where <span className="text-bone">↳ formulation</span>, <span className="text-bone">↳ material</span> and <span className="text-bone">↳ light</span> converge into a single, considered object.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
